<template>
  <div class="student-cloze-page">
    <shared-header
      ref="sharedHeader"
      @on-bound-student="handleOnBoundStudent()"
    />
    <bound-student-list-drawer
      ref="boundStudentListDrawer"
      @on-bound-student-click="handleOnBoundStudentClick"
    />

    <div class="student-cloze-list">
      <el-card class="main-card" shadow="hover">
        <template #header>
          <span class="card-title">Blank</span>
          <p class="card-desc">已完成的独立完形填空练习。点击一行查看该次最终结果。</p>
        </template>

        <div v-loading="listLoading" class="table-wrap">
          <el-table
            :data="testList"
            stripe
            border
            highlight-current-row
            empty-text="暂无已完成的完形填空练习"
            style="width: 100%"
            @row-click="onRowClick"
          >
            <el-table-column prop="subjectName" label="科目" min-width="120" show-overflow-tooltip />
            <el-table-column prop="setName" label="词表" min-width="140" show-overflow-tooltip />
            <el-table-column label="类型" width="110" align="center">
              <template #default="{ row }">
                {{ row.isNirvanaSession ? 'Nirvana' : (row.type || '完形填空') }}
              </template>
            </el-table-column>
            <el-table-column label="成绩" width="110" align="center">
              <template #default="{ row }">
                {{ row.totalCorrect }} / {{ row.totalQuestions }}
              </template>
            </el-table-column>
            <el-table-column label="正确率" width="90" align="center">
              <template #default="{ row }">{{ row.accuracyPercent }}%</template>
            </el-table-column>
            <el-table-column label="用时" width="110" align="center">
              <template #default="{ row }">
                {{ formatClozeDuration(row.totalElapsedSeconds) }}
              </template>
            </el-table-column>
            <el-table-column label="完成时间" width="160">
              <template #default="{ row }">
                {{ formatClozeDateTime(row.createdDate) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import SharedHeader from '../../shared/SharedHeader.vue'
import BoundStudentListDrawer from '../../admin/BoundStudentListDrawer.vue'
import { ElMessage } from 'element-plus'
import {
  formatClozeDuration,
  formatClozeDateTime,
  COMPLETION_TYPE,
  isCompletionType
} from './completionUtils'

export default {
  name: 'CompletionList',
  components: { SharedHeader, BoundStudentListDrawer },
  data () {
    return {
      testList: [],
      listLoading: false
    }
  },
  mounted () {
    this.loadList()
  },
  methods: {
    formatClozeDuration,
    formatClozeDateTime,

    resolveStudentId () {
      const raw =
        localStorage.getItem('targetId') || localStorage.getItem('userId')
      const studentId = Number(raw)
      return Number.isFinite(studentId) && studentId > 0 ? studentId : null
    },

    loadList () {
      const studentId = this.resolveStudentId()
      if (!studentId) {
        this.testList = []
        ElMessage.warning('未找到学生 ID，无法加载完形填空记录')
        return
      }
      this.listLoading = true
      this.$store
        .dispatch('VocStudentClozeTest/getByStudentId', {
          studentId,
          type: COMPLETION_TYPE
        })
        .then((response) => {
          const list = Array.isArray(response?.data) ? response.data : []
          this.testList = list
            .filter((item) => isCompletionType(item))
            .filter((item) => !item.status || item.status === 'finished')
            .sort((a, b) => {
              const da = new Date(a.createdDate || 0).getTime()
              const db = new Date(b.createdDate || 0).getTime()
              return db - da
            })
        })
        .catch((err) => {
          console.error(err)
          this.testList = []
          const d = err.response?.data
          const msg =
            (typeof d === 'string' && d) ||
            d?.message ||
            d?.title ||
            err.message ||
            '加载完形填空记录失败'
          ElMessage.error(String(msg))
        })
        .finally(() => {
          this.listLoading = false
        })
    },

    onRowClick (row) {
      if (!row?.id) return
      this.$router.push({
        path: '/studentblankresult',
        query: { id: String(row.id) }
      })
    },

    handleOnBoundStudent () {
      this.$refs.boundStudentListDrawer.openDrawer()
    },

    handleOnBoundStudentClick () {
      this.$refs.sharedHeader.updateBoundStudentChineseName()
      this.loadList()
    }
  }
}
</script>

<style scoped lang="scss">
.student-cloze-page {
  text-align: left;
}

.student-cloze-list {
  max-width: 1100px;
  margin: 24px auto;
  padding: 0 16px;
}

.main-card {
  border-radius: 8px;
}

.card-title {
  font-size: 1.15rem;
  font-weight: 600;
}

.card-desc {
  margin: 0.35rem 0 0;
  color: #888;
  font-size: 0.9rem;
}

.table-wrap {
  min-height: 120px;
}

:deep(.el-table__row) {
  cursor: pointer;
}
</style>
